import { create } from "zustand";
import { apiLogin } from "../services/apiLogin";
import { apiCreatorRegister } from "../services/apiCreatorRegister";
import { setAdminStatus, clearAdminStatus } from "../utils/adminManager";
import { apiLogout } from "../services";
import { ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME, setAuthTokens, USER_KEY_NAME } from "../utils/auth";

export const useAuthStore = create((set, get) => ({
    creator: null,

    fetchCreator: () => {
        const storedCreator = localStorage.getItem(USER_KEY_NAME);

        if (storedCreator) {
            const parsedCreator = JSON.parse(storedCreator);

            set({ creator: parsedCreator });
            return parsedCreator;
        }
    },

    login: async (username, password) => {
        try {
            if (!username) throw new Error("E-mail é obrigatório");
            if (!password) throw new Error("Senha é obrigatório");

            const data = await apiLogin(username, password);
            // Store tokens
            if (data.accessToken && data.refreshToken) {
                setAuthTokens(data.accessToken, data.refreshToken);
            }

            // Store user data
            set({ creator: data.creator });
            localStorage.setItem(USER_KEY_NAME, JSON.stringify(data.creator));

            setAdminStatus(data.creator);
        } catch (error) {
            throw error;
        }
    },

    logout: async () => {
        await apiLogout();
        set({ creator: null });
        localStorage.removeItem(USER_KEY_NAME);
        localStorage.removeItem(ACCESS_TOKEN_NAME);
        localStorage.removeItem(REFRESH_TOKEN_NAME);
        clearAdminStatus();
        window.location.href = '/';
    },

    updateCreator: (newCreatorData) => {
        set({ creator: newCreatorData });

        localStorage.setItem(USER_KEY_NAME, JSON.stringify(newCreatorData));

        setAdminStatus(newCreatorData);
    },

    signup: async (userData) => {
        try {
            if (!userData.nome) throw new Error("Nome é obrigatório");
            if (!userData.email) throw new Error("E-mail é obrigatório");

            const response = await apiCreatorRegister(userData);
            
            // Handle different response scenarios
            if (response.creator) {
                // New creator was created successfully
                // Automatically login with the new credentials if password was provided
                if (userData.senha) {
                    await get().login(userData.email, userData.senha);
                }
                return { 
                    success: true, 
                    message: "Cadastro realizado com sucesso!",
                    creator: response.creator 
                };
            } else if (response.passwordResetSent) {
                // Email already exists, password reset was sent to email
                return {
                    success: true,
                    message: response.message,
                    passwordResetSent: true
                };
            }
            
            return { 
                success: false, 
                message: "Unexpected response from server. Please try again later." 
            };
        } catch (error) {
            throw error;
        }
    },
}));
